import { render, staticRenderFns } from "./mapSwitch.vue?vue&type=template&id=7389118f&scoped=true&"
import script from "./mapSwitch.vue?vue&type=script&lang=js&"
export * from "./mapSwitch.vue?vue&type=script&lang=js&"
import style0 from "./mapSwitch.vue?vue&type=style&index=0&id=7389118f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7389118f",
  null
  
)

export default component.exports